// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.web.user.property.listings.accountview.zram.enums.AccountViewListingOptionType

export enum AccountViewListingOptionType {
  ARCHIVE = 'ARCHIVE',
  EDIT_LISTING = 'EDIT_LISTING',
  MANAGE_PERMISSIONS = 'MANAGE_PERMISSIONS',
  MESSAGES = 'MESSAGES',
  METRICS = 'METRICS',
  OVERVIEW = 'OVERVIEW',
  RELEASE_CLAIM = 'RELEASE_CLAIM',
  UNARCHIVE = 'UNARCHIVE',
}

export const AccountViewListingOptionType_values = [
  AccountViewListingOptionType.ARCHIVE,
  AccountViewListingOptionType.EDIT_LISTING,
  AccountViewListingOptionType.MANAGE_PERMISSIONS,
  AccountViewListingOptionType.MESSAGES,
  AccountViewListingOptionType.METRICS,
  AccountViewListingOptionType.OVERVIEW,
  AccountViewListingOptionType.RELEASE_CLAIM,
  AccountViewListingOptionType.UNARCHIVE,
] as const;
